import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiCollectionsService } from '../../../../../services/collections/api/api-collections.service';
import { AlertsService } from '../../../../../services/alerts.service';
import { LanguagesService } from '../../../../../services/languages/languages.service';
import { CollectionCardRankType } from '../../../../../enums/collections/collection-card-rank-type.enum';
import { CollectionTranslationForm, buildCollectionTranslationForms, toCollectionTranslations } from '../../../collection-translation-form.model';

@Component({
  selector: 'app-collection-card-add-modal',
  templateUrl: './collection-card-add-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class CollectionCardAddModalComponent {

  @Input() albumId: number = 0;

  @ViewChild('modal') modal!: ModalDirective;

  readonly rankTypes = Object.entries(CollectionCardRankType).filter(([, v]) => typeof v === 'number') as [string, number][];

  isLoading: boolean = false;
  name: string = '';
  rankType: CollectionCardRankType = CollectionCardRankType.One;
  translations: CollectionTranslationForm[] = [];

  private callbackSaved?: () => void;

  constructor(
    private apiCollectionsService: ApiCollectionsService,
    private alertsService: AlertsService,
    private languagesService: LanguagesService
  ) {}

  show(callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.name = '';
    this.rankType = CollectionCardRankType.One;
    this.translations = buildCollectionTranslationForms(this.languagesService.languages);
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiCollectionsService.addCollectionAlbumCard(this.albumId, this.name, this.rankType, toCollectionTranslations(this.translations)).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Card added !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error adding card : ' + error);
      }
    );
  }
}
